import { isNotNil } from 'ramda'

const EMPTY_ADDRESS = '\u2014'

type AddressInput =
  | {
      line1?: string | null
      line2?: string | null
      city?: string | null
      stateOrProvinceAbbrev?: string | null
      postalCode?: string | null
      countryCode?: string | null
    }
  | null
  | undefined

type GpsPointInput =
  | {
      lat?: number | null
      lon?: number | null
    }
  | null
  | undefined

const formatAddress = (address: AddressInput, showCountryCode = false) => {
  if (!address) return EMPTY_ADDRESS

  let result = address.line1 ? address.line1 : ''

  if (address.line2) {
    if (result) result += ' '

    result += address.line2
  }

  if (address.city) {
    if (result) result += ', '

    result += address.city
  }

  if (address.stateOrProvinceAbbrev) {
    if (result) result += ', '

    result += address.stateOrProvinceAbbrev
  }

  if (address.postalCode) {
    if (result) result += ' '

    result += address.postalCode
  }

  if (showCountryCode && address.countryCode && address.countryCode !== 'US') {
    if (result) result += ', '

    result += address.countryCode
  }

  return result ? result : EMPTY_ADDRESS
}

const formatCoordinates = (lat: number, lon: number) =>
  `${lat.toFixed(4)},${lon.toFixed(4)}`

const formatAddressOrCoordinates = (
  address: AddressInput,
  point: GpsPointInput,
  showCountryCode = false
) => {
  const formatted = formatAddress(address, showCountryCode)
  if (formatted !== EMPTY_ADDRESS) return formatted

  const lat = point?.lat
  const lon = point?.lon
  if (isNotNil(lat) && isNotNil(lon)) {
    return formatCoordinates(lat, lon)
  }

  return EMPTY_ADDRESS
}

export { EMPTY_ADDRESS, formatAddress, formatAddressOrCoordinates, formatCoordinates }
